var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "aniversario" } }, [
    _c("header", [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form" }, [
              _c("h1", [
                _vm._v(
                  "Você organiza a sua festa e seus presentes podem ajudar quem mais precisa em forma de doações."
                )
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "Ao criar um evento com nossa ferramenta, seus convidados podem doar para a Organização Social que mais toca o seu coração e que foi escolhida por você."
                )
              ]),
              _vm._v(" "),
              _c("form", [
                _c("div", { staticClass: "input" }, [
                  _c("label", [_vm._v("Informe seu e-mail")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email"
                      }
                    ],
                    attrs: {
                      type: "text",
                      name: "email",
                      placeholder: "email@email.com.br"
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.createInvite()
                        }
                      }
                    },
                    [_vm._v("CRIAR MEU CONVITE")]
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "main" } }, [
      _c("div", { staticClass: "container" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "steps row" }, [
          _c("div", { staticClass: "step col-md-3" }, [
            _c("div", { staticClass: "number" }, [
              _c(
                "span",
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: ["fas", "calendar-alt"], size: "lg" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("h3", [_vm._v("Crie um Convite")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Preencha os dados principais do seu evento: nome do evento, data, horário e local."
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "step col-md-3" }, [
            _c("div", { staticClass: "number" }, [
              _c(
                "span",
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: ["fas", "home"], size: "lg" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("h3", [_vm._v("Escolha um Projeto Social")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Escolha um projeto social que toca o seu coração e que você queira ajudar."
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "step col-md-3" }, [
            _c("div", { staticClass: "number" }, [
              _c(
                "span",
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: ["fas", "share-square"], size: "lg" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("h3", [_vm._v("Envie via Whatsapp")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Envie para os convidados do seu evento os Convites do Bem."
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "step col-md-3" }, [
            _c("div", { staticClass: "number" }, [
              _c(
                "span",
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: ["fas", "gift"], size: "lg" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("h3", [_vm._v("Comemore a transformação")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Ao receber os convites seus convidados poderão fazer doações dos valores equivalentes dos presentes que você iria receber e você acompanha as doações."
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row d-none d-sm-block" }, [
          _c("div", { staticClass: "form col-md-12" }, [
            _c("div", { staticClass: "content" }, [
              _c("h3", [
                _vm._v(
                  "Crie agora mesmo um Convite do Bem e ajude aqueles que mais precisam!"
                )
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("É simples, rápido e fácil!")]),
              _vm._v(" "),
              _c("form", [
                _c("div", { staticClass: "input" }, [
                  _c("label", [_vm._v("Informe seu e-mail")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email"
                      }
                    ],
                    attrs: {
                      type: "text",
                      name: "email",
                      placeholder: "email@email.com.br"
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.createInvite()
                        }
                      }
                    },
                    [_vm._v("CRIAR MEU CONVITE")]
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("footer", [
      _c("div", { staticClass: "container" }, [
        _vm._m(2),
        _vm._v(" "),
        _vm.projects
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c(
                    "carousel",
                    {
                      attrs: {
                        perPage: _vm.perPage,
                        navigationEnabled: _vm.navigationEnabled,
                        paginationEnabled: _vm.paginationEnabled,
                        autoplay: _vm.autoPlay
                      }
                    },
                    _vm._l(_vm.projects, function(p, k) {
                      return _c(
                        "slide",
                        {
                          key: k,
                          on: {
                            click: function($event) {
                              return _vm.openProject(p.slug)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "image" }, [
                            _c("img", { attrs: { src: p.Info.image } })
                          ]),
                          _vm._v(" "),
                          p.Categories[0] && p.Categories[0].name
                            ? _c("span", [_vm._v(_vm._s(p.Categories[0].name))])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("h3", [_vm._v(_vm._s(p.Info.title))]),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(p.Info.shortDescription))])
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "base" })
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "logo" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "intro col-md-6 offset-md-3" }, [
        _c("div", { staticClass: "base" }, [
          _c("div", { staticClass: "content" }, [
            _c("h2", [
              _vm._v(
                "Convites do Bem, uma forma diferente de celebrar e ajudar aqueles que mais precisam."
              )
            ]),
            _vm._v(" "),
            _c("b", [
              _vm._v(
                "Já pensou em organizar uma festa ou um evento solidário? \n                Com a ferramenta Convites do Bem é muito fácil e você pode escolher entre as diversas Organizações Sociais cadastradas em nossa plataforma."
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "Crie hoje mesmo um evento e envie para seus convidados os Convites do Bem!"
              )
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-4 description" }, [
        _c("h2", [
          _vm._v(
            "Conheça alguns Projetos Sociais cadastrados em nossa plataforma!"
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Escolha um projeto que toca seu coração e transforme vidas Faça do seu evento um momento de transformação social."
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11d4bddf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11d4bddf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aniversariodobem/AniversarioHome.vue
// module id = null
// module chunks = 